const {
  collectionSchema,
  itemSchema,
  environmentSchema,
  environmentsSchema,
  externalSecretsSchema
} = require('./collections');

module.exports = {
  itemSchema,
  environmentSchema,
  environmentsSchema,
  collectionSchema,
  externalSecretsSchema
};
